<template>
  <div class="col-12" style="padding: 0px">
    <div class="card">
        <div class="card-header">
          <h4>
            {{ table.title }}
          </h4>
          <div>
            <button class="btn btn-warning btn-sm" style="border-radius: 0px; background: #F0A04B !important; border: none" @click="print()">
              <i class="fa fa-print"></i>
              طباعة الجدول
            </button>
            <button class="btn btn-primary btn-sm" style="border-radius: 0px; border: none" v-b-modal.shuffle>
              <i class="fa fa-random"></i>
              توزيع تلقائي الآن
            </button>
          </div>
        </div>
        <b-modal id="shuffle" title="توزيع الآن" hide-footer>
            <div class="shadow card card-body border" style="margin: 10px">
                <span><i class="fa fa-check-square"></i> اختيار المعلمين</span>
                <div class="form-check" v-for="t in teachers" :key="t._id">
                  <label class="form-check-label">
                    <input type="checkbox" class="form-check-input" v-model="shuffle.teachers" :value="t._id">
                    {{ t.name }}
                  </label>
                </div>
            </div>
            <div class="shadow card card-body border" style="margin: 10px">
                <span><i class="fa fa-check-square"></i> اختيار الفصول</span>
                <div class="form-check" v-for="t in classrooms" :key="t._id">
                  <label class="form-check-label">
                    <input type="checkbox" class="form-check-input" v-model="shuffle.classrooms" :value="t._id">
                    {{ t.title }}
                  </label>
                </div>
            </div>
            <div class="shadow card card-body border" style="margin: 10px">
                <span><i class="fa fa-check-square"></i> اختيار المواد</span>
                <div class="form-check" v-for="t in subjects" :key="t._id">
                  <label class="form-check-label">
                    <input type="checkbox" class="form-check-input" v-model="shuffle.subjects" :value="t._id">
                    {{ t.title }}
                  </label>
                </div>
            </div>
            <div class="col-12 text-center g">
              <button class="btn btn-primary" style="border-radius: 0px" @click="shuffleNow()" v-if="!shuffle.loading">
                <i class="fa fa-check"></i>
                توزيع الآن
              </button>
              <button class="btn btn-lg text-primary" style="border-radius: 0px" disabled v-if="shuffle.loading">
                <img :src="require('@/assets/images/loading.svg')" width="32">
                جاري التوزيع...
              </button>
              <span v-if="shuffle.loading" class="text-muted">
                <br>
                ربما يستغرق دقائق...
              </span>
            </div>
        </b-modal>
        <div class="card-body text-center" v-if="loading">
          <img :src="require('@/assets/images/loading.svg')" width="60">
          جاري التحميل...
        </div>
        <div class="card-body" v-if="table.time && !loading">
          <div class="col-12 g" v-if="logs.length">
            <div class="alert alert-warning g border shadow" style="border: 2px solid #777 !important">
              <h5 class="text-danger"><i class="fa fa-warning"></i> ملاحظات التوزيع</h5>
              <ol>
                <li class="text-dark" v-for="ix in logs" :key="ix" v-html="ix"></li>
              </ol>
              <div class="col-12">
                <a href="javascript:;" @click="logs = []"><i class="fa fa-times"></i> اخفاء التنبيه</a>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-6 col-lg-2 g" v-for="c in classrooms" :key="c._id">
              <div class=" g adsd" :style="`border-radius: 5px; background: #F4F8D3; border: 2px solid #999; ` + (selected_classroom == c._id ? 'border: 2px solid green; background: #D1F8EF' : '')" @click="viewClassroom(c._id)">
                <strong>{{ c.classname + ' ~ ' + c.title }}</strong>
              </div>
            </div>
          </div>
          <div class="col-12 col-lg-6 c g" v-if="noSelect">
            <div class="alert alert-warning text-center g">
              اختر الفصل
            </div>
          </div>
          <div class="col-12 g" v-if="!noSelect && items.length == 0">
            <div class="alert alert-danger text-center g">
              لا يوجد جدول لهذا الفصل
            </div>
          </div>
            <div class="col-12 table-responsive" id="table" v-if="!noSelect">
              <h4 class="dnone">جدول فصل {{ className(selected_classroom) }}</h4>
              <table class="table-bordered table table-sm table-hover table-striped">
                <thead>
                  <th>
                    <span style="float: left">الحصة</span>
                    <br>
                    <span style="border-top: 1px solid #ddd; width: 100% !important; float: right">اليوم</span>
                  </th>
                  <th v-for="(a,b) in Array(table.time.max_lessons).fill(0)" :key="b">
                    <strong>الحصة
                    {{ b+1 }}</strong>
                    <br>
                    <small class="text-muted">
                      {{ table.time.lessons_times[b+1][0] }} &mdash; {{ table.time.lessons_times[b+1][1] }}
                    </small>
                  </th>
                </thead>
                <tbody>
                  <tr v-for='day in table.time.days' :key="day">
                    <td>
                      <strong>{{ day
                      .replace("Sunday", "الاحد")
                      .replace("Monday", "الاثنين")
                      .replace("Tuesday", "الثلاثاء")
                      .replace("Wednesday", "الاربعاء")
                      .replace("Thursday", "الخميس")
                      .replace("Saturday", "السبت")
                      .replace("Friday", "الجمعة")
                       }}</strong>
                    </td>
                    <td v-for="(a,b) in Array(table.time.max_lessons).fill(0)" :key="b" :class="!table.time.days_lessons[day][b+1] ? 'bg-light-secondary text-center' : ''">
                      <small class="text-muted" v-if="!table.time.days_lessons[day][b+1]">
                        <i>غير مفعلة</i>
                      </small>
                      <template v-if="!edits[day+b]">
                        <small v-if="table.time.days_lessons[day][b+1]">
                          <a href="javascript:;" @click="edits = {};edits[day+b] = true; currentItem = getItem(day, b+1).teacher_id + ',' + getItem(day, b+1).subject_id; refresh()">
                            <i class="fa fa-edit"></i>
                          </a>&nbsp;
                          <strong>{{ subjectName(getItem(day, b+1).subject_id) }}</strong>
                          <br>
                          {{ teacherName(getItem(day, b+1).teacher_id) }}
                        </small>
                      </template>
                      <template v-if="edits[day+b]">
                        <select class="form-control form-control-sm" v-model="currentItem" @change="editItem(day, b+1)">
                          <option value="undefined,undefined">-- اختر --</option>
                         <option v-for="y in classroomTeachers(getItem(day, b+1).classroom_id)" :key="y._id" :value="y._id">
                          {{ y.title }}
                         </option>
                        </select>
                      </template>
                    </td>
                  </tr>
                </tbody>
              </table>
              <div class="form-check">
                <label class="form-check-label">
                  <input type="checkbox" class="form-check-input" v-model="checks">
                  التأكد من عدم التعارضات او تجاوز النصاب عند التعديل اليدوي.
                </label>
              </div>
            </div>
        </div>
    </div>
    <div class="card card-body">
      <h5>
        <i class="fa fa-random"></i>
        ما تم توزيعه
      </h5>
      <div class="row">
        <div class="col-12 col-lg-6 g table-responsive" style="min-height: 0px !important">
          <table class="table table-hover table-sm table-bordered">
            <thead>
              <th>
                المعلم
              </th>
              <th>
                النصاب
              </th>
              <th>
                ما تم توزيعه
              </th>
              <th>
                العدد الاقصى للحصص
              </th>
              <th>
                التفاصيل
              </th>
            </thead>
            <tbody>
            <b-modal id="tdetails" title="التفاصيل" hide-footer>
              <table class="table table-hover table-sm table-bordered">
                <thead>
                  <th>
                    الفصل
                  </th>
                  <th>
                    المادة
                  </th>
                  <th>
                    اليوم
                  </th>
                  <th>
                    الحصة
                  </th>
                </thead>
                <tbody v-for="item in teacherDetails" :key="item._id">
                  <td>
                    {{ className(item.classroom_id) }} 
                  </td>
                  <td>
                    {{ subjectName(item.subject_id) }} 
                  </td>
                  <td>
                    {{ item.day.replace('Sunday', "الاحد")
                    .replace('Monday', "الاثنين")
                    .replace('Tuesday', "الثلاثاء")
                    .replace('Wednesday', "الاربعاء")
                    .replace('Thursday', "الخميس")
                    .replace('Firday', "الجمعة")
                    .replace('Saturday', "السبت") }} 
                  </td>
                  <td>
                    {{ item.lesson }} 
                  </td>
                </tbody>
              </table>
            </b-modal>
              <tr v-for="t in teachers" :key="t._id" :class="t.items_length < t.subjects_items ? 'bg-light-primaryx' : (t.items_length > t.subjects_items ? 'bg-light-danger' : 'bg-light-success')">
                <td>
                  {{ t.name }}
                </td>
                <td>
                  {{ t.subjects_items }}
                </td>
                <td>
                  {{ t.items_length }}
                </td>
                <td>
                  {{ t.config.max_lessons }}
                </td>
                <td>
                  <button v-b-modal.tdetails class="btn btn-sm text-primary" @click="teacherDetails = originalItems.filter(function(x){
                    if(x.teacher_id == t._id){
                      return x;
                    }else{
                      return false;
                    }
                  })">
                    <i class="fa fa-list"></i>
                    التفاصيل
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>

            <b-modal id="sdetails" title="التفاصيل" hide-footer>
              <table class="table table-hover table-sm table-bordered">
                <thead>
                  <th>
                    الفصل
                  </th>
                  <th>
                    ما تم توزيعه
                  </th>
                  <th>
                    العدد الاقصى للحصص
                  </th>
                </thead>
                <tbody v-for="item in teacherDetails2" :key="item._id">
                  <td>
                    {{ item.title }}
                  </td>
                  <td>
                    {{ item.done }}
                  </td>
                  <td>
                    {{ item.lessons }}
                  </td>
                </tbody>
              </table>
            </b-modal>
        <div class="col-12 col-lg-6 g table-responsive"  style="min-height: 0px !important">
          <table class="table table-hover table-sm table-bordered">
            <thead>
              <th>
                المادة
              </th>
              <th>
                ما تم توزيعه
              </th>
              <th>
                العدد الاقصى للحصص
              </th>
              <th>
                التفاصيل
              </th>
            </thead>
            <tbody>
              <tr v-for="t in subjects" :key="t._id" :class="t.items_length < t.total_items ? 'bg-light-primaryx' : (t.items_length > t.total_items ? 'bg-light-danger' : 'bg-light-success')">
                <td>
                  {{ t.title }}
                </td>
                <td>
                  {{ t.items_length }}
                </td>
                <td>
                  {{ t.total_items }}
                </td>

                <td>
                  <button v-b-modal.sdetails class="btn btn-sm text-primary" @click="getSubjectDetails(t)">
                    <i class="fa fa-list"></i>
                    التفاصيل
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Ripple from "vue-ripple-directive";
function makeid(length) {
    let result = '';
    const characters = 'abcdefghkmnoprstuvwxyz123456789';
    const charactersLength = characters.length;
    let counter = 0;
    while (counter < length) {
      result += characters.charAt(Math.floor(Math.random() * charactersLength));
      counter += 1;
    }
    return result;
}
import { VBModal, BModal, BFormInput, BDropdown, BDropdownItem } from "bootstrap-vue";
export default {
    components: {
        // Layouts
        BDropdown, BDropdownItem,
        BModal,BFormInput},
    directives: {
        Ripple,
        "b-modal": VBModal,
    },
  data(){
    return {
      id: window.location.href.split("table/")[1],
      user: JSON.parse(localStorage.getItem("user")),
      edits: {},
      table: {},
      teacherDetails: [],
      teacherDetails2: [],
      currentItem: "",
      selectForEdit: "",
      teachers: [],
      subjects: [],
      classrooms: [],
      teachersObj: {},
      subjectsObj: {},
      classroomsObj: {},
      noSelect: true,
      selected_classroom: "",
      items: [],
      checks: true,
      originalItems: [],
      shuffle: {
        teachers: [],
        subjects: [],
        classrooms: [],
        loading: false
      },
      loading: true,
      logs: []
    }
  },
  methods: {
    getSubjectDetails(subject){
      var g = this;
      var arr = [];
      subject.classrooms.forEach(function(a){
        var x = {
          title: g.className(a),
          lessons: 
          (subject.customClassesLessonsSingle[a] ? new Number(subject.customClassesLessonsSingle[a]) : subject.single_lessons) 
          + 
          ((subject.customClassesLessonsDouble[a] ? new Number(subject.customClassesLessonsDouble[a]) : subject.double_lessons) * 2),
          done: 0
        };
        g.originalItems.forEach(function(c){
          if(c.subject_id == subject._id && c.classroom_id == a){
            x.done = x.done + 1;
          }
        })
        arr.push(x)
      })
      g.teacherDetails2 = arr;
    },
    editItem(day, lesson){
      var g = this;
      $.post(api + '/user/tables/edit-item', {
          jwt: g.user.jwt,
          day: day,
          lesson: lesson,
          table_id: g.table._id,
          teacher_id: g.currentItem.split(",")[0],
          subject_id: g.currentItem.split(",")[1],
          classroom_id: g.selected_classroom,
          checks: g.checks
      }).then(function(r){
        g.edits = {};
        g.getTable(false)
            g.gett()
        if(r.status == 200){
          alert(r.response, 200)
        }
      })
    },
    classroomTeachers(id){
      var g = this;
      var arr2 = [];
      var arr = [];
      g.items.forEach(function(a){
        if(!arr2.includes(a.teacher_id + ',' + a.subject_id)){
          arr2.push(a.teacher_id + ',' + a.subject_id)
          if(g.subjectName(a.subject_id) && g.teacherName(a.teacher_id)){
            arr.push({
              _id: a.teacher_id + ',' + a.subject_id,
              title: g.subjectName(a.subject_id) + ' ~ ' + g.teacherName(a.teacher_id)
            })
          }
        }
      })
      return arr;
    },
    refresh(){
      this.items = JSON.parse(JSON.stringify(this.items))
    },
    print(){
      if(this.noSelect){
        return alert("لم يتم اختيار فصل", 200)
      }
      var g = this;
      var win = window.open()
      win.document.write(`
      <html dir='rtl'>
        <head>
          <style>
            @page{
              margin: 0px
            }
            table, td, th {
              border: 1px solid;
            }

            table {
              width: 100%;
              border-collapse: collapse;
            }
            td{
              text-align: center
            }
            thead th{
              background: #FFF6DA !important
            }
          </style>
        </head>
        <body>
          ${$("#table").html()}
        </body>
      </html>
      `)
      win.document.close()
      win.print()
      win.close()
    },
    shuffleNow(){
      var g = this;
      g.logs = []
      g.shuffle.loading = true;
      $.post(api + '/user/tables/shuffle-arr', {
          jwt: g.user.jwt,
          id: g.id,
          teachers: JSON.stringify(g.shuffle.teachers),
          subjects: JSON.stringify(g.shuffle.subjects),
          classrooms: JSON.stringify(g.shuffle.classrooms)
      }).then(function(r){
          g.shuffle.loading = false;
          if(r.status != 100){
              alert(r.response, 200)
          }else{
            //
            const data = r.response;

function generateSchoolTimetable(data) {
  const timetable = [];
  const tableId = data.table._id;
  const days = data.time.days;
  const maxLessonsPerDay = data.time.max_lessons;

  // Create maps for quicker lookups and tracking
  const subjectsMap = new Map(data.subjects.map(sub => [sub._id, { ...sub, remainingLessons: {}, remainingDoubleLessons: {} }]));
  const teachersMap = new Map(data.teachers.map(teacher => [teacher._id, { ...teacher, assignedLessonsCount: 0, availability: {} }]));

  // New data structure to track subject assignments per classroom per day for adjacency checks
  // classroomDailySubjectTracker: Map<classroom_id, Map<day, Map<subject_id, Array<lesson_number>>>>
  const classroomDailySubjectTracker = new Map();

  // Initialize remaining lessons for each subject in each classroom
  data.classrooms.forEach(classroom => {
    classroomDailySubjectTracker.set(classroom._id, new Map()); // Initialize for classroom
    classroom.subjects.forEach(subjectId => {
      const subject = subjectsMap.get(subjectId);
      if (subject) {
        let singleLessonsForClassroom = subject.single_lessons;
        let doubleLessonsForClassroom = subject.double_lessons; // Get base double lessons

        // Check for custom lessons per classroom for single lessons
        if (subject.customClassesLessonsSingle && subject.customClassesLessonsSingle[classroom._id]) {
          singleLessonsForClassroom = parseInt(subject.customClassesLessonsSingle[classroom._id]);
        }
        // Check for custom lessons per classroom for double lessons
        if (subject.customClassesLessonsDouble && subject.customClassesLessonsDouble[classroom._id]) {
          doubleLessonsForClassroom = parseInt(subject.customClassesLessonsDouble[classroom._id]);
        }

        subject.remainingLessons[classroom._id] = singleLessonsForClassroom;
        subject.remainingDoubleLessons[classroom._id] = doubleLessonsForClassroom;
      }
    });

    // Initialize daily subject tracker for each classroom and day
    days.forEach(day => {
      classroomDailySubjectTracker.get(classroom._id).set(day, new Map());
      classroom.subjects.forEach(subjectId => {
        classroomDailySubjectTracker.get(classroom._id).get(day).set(subjectId, []);
      });
    });
  });

  // Initialize teacher availability (all lessons available initially)
  data.teachers.forEach(teacher => {
    days.forEach(day => {
      teachersMap.get(teacher._id).availability[day] = new Set(Array.from({ length: maxLessonsPerDay }, (_, i) => i + 1));
    });
  });

  // Iteratively assign lessons
  let lessonsAssignedInIteration = true; // Flag to control the outer loop
  let attemptCount = 0;
  const maxAttempts = 1000; // Prevent infinite loops in case of unresolvable constraints

  while (lessonsAssignedInIteration && attemptCount < maxAttempts) {
    lessonsAssignedInIteration = false;
    attemptCount++;

    for (const day of days) {
      // Prioritize assigning 'is_first' subjects earlier in the day
      // Create an array of lesson slots, then sort based on 'is_first' preference
      const lessonSlots = Array.from({ length: maxLessonsPerDay }, (_, i) => i + 1);

      for (const lesson of lessonSlots) { // Iterate through lesson slots
        // Shuffle classrooms to distribute assignments more evenly and avoid sticking to one class
        const shuffledClassrooms = [...data.classrooms];
        shuffleArray(shuffledClassrooms);

        for (const classroom of shuffledClassrooms) {
          // Check if this slot is already taken in the timetable for this classroom, day, and lesson
          const isSlotTaken = timetable.some(
            entry => entry.classroom_id === classroom._id &&
                     entry.day === day &&
                     entry.lesson === lesson
          );
          if (isSlotTaken) {
            continue; // Skip if the slot is already occupied
          }

          // Separate subjects into 'is_first' and others for prioritized assignment
          const subjectsWithIsFirst = [];
          const otherSubjects = [];

          classroom.subjects.forEach(subjectId => {
            const subject = subjectsMap.get(subjectId);
            if (subject && ((subject.remainingLessons[classroom._id] || 0) > 0 || (subject.remainingDoubleLessons[classroom._id] || 0) > 0)) {
                if (subject.is_first) {
                    subjectsWithIsFirst.push(subjectId);
                } else {
                    otherSubjects.push(subjectId);
                }
            }
          });
          
          // Shuffle within categories
          shuffleArray(subjectsWithIsFirst);
          shuffleArray(otherSubjects);

          const orderedSubjects = [...subjectsWithIsFirst, ...otherSubjects];

          for (const subjectId of orderedSubjects) {
            const subject = subjectsMap.get(subjectId);

            // Determine if we should attempt to assign a double lesson or a single lesson
            const hasRemainingDouble = (subject.remainingDoubleLessons[classroom._id] || 0) > 0;
            const hasRemainingSingle = (subject.remainingLessons[classroom._id] || 0) > 0;

            if (!hasRemainingDouble && !hasRemainingSingle) {
                continue; // No more lessons for this subject in this classroom
            }

            // --- Constraint: Teacher cannot teach two different classes at the same time ---
            // (Implicitly handled by teacher.availability, see previous explanation)

            // --- Constraint: Same subject, same class, same day (max 2 consecutive) ---
            const assignedSlotsForSubjectInClass = classroomDailySubjectTracker.get(classroom._id).get(day).get(subjectId);
            let canAssignSubjectToClassToday = true;
            let attemptingDoubleLesson = false;

            if (assignedSlotsForSubjectInClass.length >= 2) {
              // Already assigned 2 lessons for this subject in this class today (max allowed for adjacent)
              canAssignSubjectToClassToday = false;
            } else if (assignedSlotsForSubjectInClass.length === 1) {
              const prevLesson = assignedSlotsForSubjectInClass[0];
              // If there's one lesson, the new one must be immediately adjacent to form a double lesson
              if (Math.abs(lesson - prevLesson) !== 1) {
                canAssignSubjectToClassToday = false; // Not adjacent, so cannot be a second part of a double lesson
              } else {
                // If it is adjacent, ensure there's a double lesson slot needed
                if (!hasRemainingDouble) {
                    canAssignSubjectToClassToday = false; // Can't form a double lesson if no double lessons remaining
                } else {
                    attemptingDoubleLesson = true; // This will be the second part of a double lesson
                }
              }
            } else { // assignedSlotsForSubjectInClass.length === 0
                // If no lessons assigned yet for this subject today in this class
                // Prioritize assigning double lessons if available and possible
                if (hasRemainingDouble && lesson < maxLessonsPerDay && !isSlotTaken && 
                    !timetable.some(entry => entry.classroom_id === classroom._id && entry.day === day && entry.lesson === lesson + 1)) {
                    // Check if the next slot is also available in the timetable for this classroom
                    // This is for checking if a double lesson *can* be placed here at all.
                    // The actual teacher availability for the next slot is checked below.
                    attemptingDoubleLesson = true;
                } else if (!hasRemainingSingle && !hasRemainingDouble) {
                    canAssignSubjectToClassToday = false; // No single or double lessons left
                }
            }

            if (!canAssignSubjectToClassToday) {
              continue; // Skip if this assignment violates adjacency constraint
            }

            // Find a suitable teacher for this subject and classroom
            const potentialTeachers = data.subjectsofteacher[subjectId] || [];
            shuffleArray(potentialTeachers);

            for (const teacherId of potentialTeachers) {
              const teacher = teachersMap.get(teacherId);

              const teacherAssignedToClassroomSubject = teacher.assigns.includes(`${classroom._id},${subjectId}`);
              const isTeacherAvailable = teacher.availability[day].has(lesson);
              const teacherMaxLessonsReached = teacher.assignedLessonsCount >= teacher.config.max_lessons;

              if (teacherAssignedToClassroomSubject && isTeacherAvailable && !teacherMaxLessonsReached) {
                let assignedSuccessfully = false;
                if (attemptingDoubleLesson) {
                    // Try to assign a double lesson
                    const nextLesson = lesson + 1;
                    const isNextSlotAvailableForTeacher = teacher.availability[day].has(nextLesson);
                    const isNextSlotTakenInTimetable = timetable.some(
                        entry => entry.classroom_id === classroom._id &&
                                 entry.day === day &&
                                 entry.lesson === nextLesson
                    );

                    if (isNextSlotAvailableForTeacher && !isNextSlotTakenInTimetable) {
                        // Assign the first part of the double lesson
                        timetable.push({
                            classroom_id: classroom._id,
                            table_id: tableId,
                            lesson: lesson,
                            day: day,
                            subject_id: subjectId,
                            teacher_id: teacherId
                        });
                        // Assign the second part of the double lesson
                        timetable.push({
                            classroom_id: classroom._id,
                            table_id: tableId,
                            lesson: nextLesson,
                            day: day,
                            subject_id: subjectId,
                            teacher_id: teacherId
                        });

                        subject.remainingDoubleLessons[classroom._id]--; // Decrement double lessons count
                        teacher.assignedLessonsCount += 2;
                        teacher.availability[day].delete(lesson);
                        teacher.availability[day].delete(nextLesson);
                        classroomDailySubjectTracker.get(classroom._id).get(day).get(subjectId).push(lesson, nextLesson);
                        assignedSuccessfully = true;
                    }
                } else if (hasRemainingSingle && assignedSlotsForSubjectInClass.length === 0) {
                    // Assign a single lesson only if no lessons for this subject/class/day yet
                    timetable.push({
                        classroom_id: classroom._id,
                        table_id: tableId,
                        lesson: lesson,
                        day: day,
                        subject_id: subjectId,
                        teacher_id: teacherId
                    });

                    subject.remainingLessons[classroom._id]--; // Decrement single lessons count
                    teacher.assignedLessonsCount++;
                    teacher.availability[day].delete(lesson);
                    classroomDailySubjectTracker.get(classroom._id).get(day).get(subjectId).push(lesson);
                    assignedSuccessfully = true;
                }

                if (assignedSuccessfully) {
                    lessonsAssignedInIteration = true; // Mark that a lesson was assigned in this iteration
                    break; // Move to the next classroom/slot after assigning this lesson
                }
              }
            }
            if (lessonsAssignedInIteration) break; // If a lesson was assigned for this classroom, move to next classroom
          }
        }
      }
    }
  }

  // Optional: Check for unassigned lessons
  const unassignedLessons = [];
  subjectsMap.forEach(subject => {
    for (const classroomId in subject.remainingLessons) {
      if ((subject.remainingLessons[classroomId] || 0) > 0) {
        unassignedLessons.push({
          subject: data.names[subject._id],
          classroom: data.names[classroomId],
          type: 'single',
          remaining: subject.remainingLessons[classroomId]
        });
      }
      if ((subject.remainingDoubleLessons[classroomId] || 0) > 0) {
        unassignedLessons.push({
          subject: data.names[subject._id],
          classroom: data.names[classroomId],
          type: 'double',
          remaining: subject.remainingDoubleLessons[classroomId]
        });
      }
    }
  });

  if (unassignedLessons.length > 0) {
    console.warn("Could not assign all lessons. Remaining unassigned lessons:", unassignedLessons);
    console.warn("Details:", unassignedLessons);
  }

  return timetable;
}

// Helper function to shuffle an array (Fisher-Yates algorithm)
function shuffleArray(array) {
    for (let i = array.length - 1; i > 0; i--) {
        const j = Math.floor(Math.random() * (i + 1));
        [array[i], array[j]] = [array[j], array[i]];
    }
}

            // --- Run the timetable generation ---
            const result = generateSchoolTimetable(data);
            $.post(api + '/user/tables/shuffle', {
                jwt: g.user.jwt,
                arr: JSON.stringify(result),
                id: g.id
            }).then(function(r){

            })
            //
          }
      }).fail(function(){
          g.shuffle.loading = false;
          alert('حدث خطأ في الاتصال', 200)
      })
    },
    getTable(nn=true){
      var g = this;
      g.loading = true;
      g.noSelect = true;
      $.post(api + '/user/tables/table', {
          jwt: g.user.jwt,
          id: g.id
      }).then(function(r){
          g.loading = false;
          if(r.status != 100){
              alert(r.response, 200)
          }else{
              g.table = r.response
              g.originalItems = r.response.items;
              if(!nn){
                g.viewClassroom(g.selected_classroom)
              }
          }
      }).fail(function(){
          g.loading = false;
          alert('حدث خطأ في الاتصال', 200)
      })
    },
    viewClassroom(id){
      this.noSelect = false;
      this.selected_classroom = id;
      this.items = this.originalItems.filter(function(x){
        if(x.classroom_id == id){
          return x;
        }
        return false;
      })
    },
    getItem(day, index){
      var x = {}, g = this;
      g.items.forEach(function(a){
        if(a.day == day && index == a.lesson){
          x = a;
        }
      })
      return x;
    },
    teacherName(id){
      var g = this;
      if(g.teachersObj[id]){
        return g.teachersObj[id].name;
      }
      return ""
    },
    subjectName(id){
      var g = this;
      if(g.subjectsObj[id]){
        return g.subjectsObj[id].title;
      }
      return ""
    },
    className(id){
      var g = this;
      if(g.classroomsObj[id]){
        return ' ~ ' + g.classroomsObj[id].title;
      }
      return ""
    },
    gett(){
      var g = this;
      $.post(api + '/user/classrooms/list', {
          jwt: g.user.jwt,
          id: g.id
      }).then(function(r){
          if(r.status != 100){
              alert(r.response, 200)
          }else{
              g.classrooms = r.response
              g.shuffle.classrooms = r.response.map(function(x){return x._id})
              g.classrooms.forEach(function(a){
                g.classroomsObj[a._id] = a;
              })
          }
      }).fail(function(){
          alert('حدث خطأ في الاتصال', 200)
      })
      $.post(api + '/user/subjects/list-s', {
          jwt: g.user.jwt,
          id: g.id,
          table_id: g.id
      }).then(function(r){
          if(r.status != 100){
              alert(r.response, 200)
          }else{
              g.subjects = r.response
              g.shuffle.subjects = r.response.map(function(x){return x._id})
              g.subjects.forEach(function(a){
                g.subjectsObj[a._id] = a;
              })
          }
      }).fail(function(){
          alert('حدث خطأ في الاتصال', 200)
      })
    }
  },
  created(){
    var g = this;
    g.getTable()
    $.post(api + '/user/teachers/list-s', {
        jwt: g.user.jwt,
        id: g.id,
        table_id: g.id
    }).then(function(r){
        if(r.status != 100){
            alert(r.response, 200)
        }else{
            g.teachers = r.response
            g.shuffle.teachers = r.response.map(function(x){return x._id})
            g.teachers.forEach(function(a){
              g.teachersObj[a._id] = a;
            })
        }
    }).fail(function(){
        alert('حدث خطأ في الاتصال', 200)
    })
    g.gett()
  }
}
</script>

<style>
.adsd:hover{
  background: #D1F8EF !important;
  cursor: pointer;
}
</style>